<div class="div-arriere-plan-action" (click)="onDismiss(true)"></div>
<div class="div-global-action" (click)="$event.stopPropagation()">
  <div id="center-square">
    <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%">
      <div class="flex gap-10 mb-30">
        <img class="close-icon" src="assets/close_cross_black.svg" (click)="onDismiss(true)">
        <div class="flex gap-10">
          <img width="20px" src="assets/representative-icon.svg" alt="representative icon">
          <h3 class="bold header_title light-blue">REPRÉSENTATIVITÉ SYNDICALE</h3>
        </div>
      </div>

      <!-- <div class="dark-blue bg-light-gray radius-10 p-20 mb-10">
        <p class="text-md" style="margin: 5px 0px 5px 0px;">
          3ème Collège - Cadres : collège(s) en carence, non inclus dans le calcul.
        </p>
      </div> -->

      <div class="voters-container">
        <div id="custom-grid" class="mb-10"
          style="display: grid; grid-template-columns: 2.5fr 2fr 2fr 3.5fr; gap: 10px;">
          <p class="dark-gray no-margin bold text-left">Organisation syndicale</p>
          <p class="dark-gray no-margin bold text-right">Bulletins</p>
          <p class="dark-gray no-margin bold text-right">% représentativité</p>
          <p class="dark-gray no-margin bold text-center">Statut</p>
        </div>
        <div *ngFor="let list of representationData.lines; let i = index" class="dark-blue"
          style="display: grid; grid-template-columns: 2.5fr 2fr 2fr 3.5fr; gap: 10px; padding: 10px 0px; border-top: solid 1px #C3DAFD">
          <div class="flex align-items-center gap-10">
            <img *ngIf="list.logo" [src]="list.logo" alt="" width="30px">
            <p class="no-margin">{{list.name}}</p>
          </div>
          <div class="flex align-items-center content-end">
            <p class="no-margin">{{list.votes}}</p>
          </div>
          <div class=" flex align-items-center content-end">
            <p class="no-margin">{{list.audience | number:'1.0-2'}}%</p>
          </div>
          <div class="text-center">
            <p class="no-margin p-10 radius-10 margin-center bg-light-green green w-fit" *ngIf="list.audience >= 10">✓
              Représentative</p>
            <p class="no-margin p-10 radius-10 margin-center bg-light-red red w-fit" *ngIf="list.audience < 10">✗ Non
              Représentative</p>
          </div>
        </div>
      </div>

      <div>
        <div class="bg-pastel-blue radius-10 p-20 dark-blue mb-10 mt-10">
          <p class="no-margin text-sm">Total des suffrages valablement exprimés : <span
              class="bold">{{representationData.totalVotes}} Bulletins</span></p>
        </div>

        <div class="marine-blue p-20 bg-pastel-blue radius-10">
          <p class="bold no-margin mb-10 text-xs">Comment est calculée la représentativité ? </p>
          <p class="no-margin text-xs">
            La représentativité syndicale est calculée uniquement à partir des
            résultats du <span class="bold">1er tour des élections des titulaires</span> tout collèges confondus. Le
            pourcentage est obtenu en
            divisant le nombre de bulletins d'une liste par le total des bulletins valablement exprimés, multiplié par
            100. Une organisation syndicale est considérée comme <span class="bold">représentative si elle atteint au
              moins 10 %</span>.
          </p>
        </div>
      </div>
      <div>
        <div style="display: flex; justify-content: space-between; flex-direction: column; align-items: center;">
          <p (click)=onDismiss(false) class="dark-blue pointer" style="margin-bottom: 0px;">Fermer</p>
        </div>
      </div>
    </div>
  </div>
</div>